import React from "react";
import Skeleton from "@/components/ui/skeleton";
import { uniqueId } from "lodash";

const DrilldownSkeleton: React.FC = () => {
  return (
    <div key={uniqueId()} className="flex pl-4 gap-4">
      <Skeleton className="w-44 h-6" />
      <Skeleton className="w-[calc(90%-10rem)] h-6" />
    </div>
  );
};

export default DrilldownSkeleton;
